export default {
  drawerWidth: 215, // drawer / Side Bar width
};
